import { AbstractFWCustomParams } from 'tag/ts/tag/ads/freewheel/abstract/AbstractFWCustomParams';
import { AdSetupDefinition } from 'tag/ts/tag/model/type/ads/AdSetupDefinition';
export class FWCustomParams extends AbstractFWCustomParams {
    adParams;
    constructor(argument) {
        super({
            name: 'FWCustomParams',
            ...argument
        });
        switch (argument?.adSetupInfo?.setup?.definition) {
            case AdSetupDefinition.IMA:
                this?.logger?.log('AdSetupDefinition = IMA');
                this.adParams = this.createIMAParams();
                break;
            case AdSetupDefinition.DAI_SDK:
            case AdSetupDefinition.DAI_SSB:
                this?.logger?.log('AdSetupDefinition = DAI_SDK | DAI_SSB');
                this.adParams = this.createDAIParams();
                break;
            case AdSetupDefinition.DAI_API:
                this?.logger?.log('AdSetupDefinition = DAI_API');
                this.adParams = this.createDAIAPIParams();
                break;
            case AdSetupDefinition.LINEAR_AD_TRACKING:
                this?.logger?.log('AdSetupDefinition = LINEAR_AD_TRACKING');
                this.adParams = this.createLinearParams();
                this.slotParams = this.createLinearSlotParams();
                break;
        }
    }
    get adParameters() {
        return this.adParams;
    }
}
